export const enum ProductivityManagerTabsEnum {
  Team = 'team',
  Individual = 'individual',
  Personal = 'personal',
  Departments = 'departments',
}
